import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed w-full z-50 bg-black/90 backdrop-blur-md border-b border-red-500/20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Left Menu */}
          <nav className="hidden lg:flex space-x-8">
            {navigation.slice(0, 2).map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-white hover:text-red-400 transition-colors duration-300 font-medium ${
                  isActive(item.path) ? 'text-red-400' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Logo Center */}
          <Link to="/" className="flex-shrink-0">
            <motion.div 
              className="text-center"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              <h1 className="text-3xl font-bold bg-gradient-to-r from-red-400 via-yellow-400 to-red-400 bg-clip-text text-transparent">
                LUXE SALON
              </h1>
              <p className="text-xs text-yellow-400 tracking-widest">BEAUTY & STYLE</p>
            </motion.div>
          </Link>

          {/* Right Menu */}
          <nav className="hidden lg:flex space-x-8">
            {navigation.slice(2).map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-white hover:text-red-400 transition-colors duration-300 font-medium ${
                  isActive(item.path) ? 'text-red-400' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="lg:hidden py-4 border-t border-red-500/20"
          >
            <nav className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`text-white hover:text-red-400 transition-colors duration-300 font-medium ${
                    isActive(item.path) ? 'text-red-400' : ''
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;